// Component for HYK-792: Modal for prompting users to add social networks
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDraggableSheet } from '../../../helpers/hooks';
import Icon from '../Icon/Icon';
import './SocialNetworksPrompt.scss';

const SocialNetworksPrompt = ({ open, onClose }) => {
  const navigate = useNavigate();
  const {
    sheetStyle,
    overlayHandlers,
  } = useDraggableSheet({ onClose, lockBodyScroll: open });

  const handleAddNetworks = () => {
    navigate('/edit-networks');
    onClose();
  };

  if (!open) return null;

  return (
    <div className="social-networks-prompt-overlay" {...overlayHandlers}>
      <div className="sheet" style={sheetStyle} onClick={(e) => e.stopPropagation()}>
        <div className="pull-bar" />
        <div className="content">
          <div className="title">Add Your Social Networks</div>
          <p className="message">
            Connect your social networks to your HYK profile and make it easier for others to find and follow you.
          </p>
          <div className="actions-social">
            <button 
              className="btn red-btn btn-full-v" 
              onClick={handleAddNetworks}
              aria-label="Add social networks"
            >
              Add Social Networks
            </button>
            <button 
              className="link-btn" 
              onClick={onClose}
              aria-label="Close"
            >
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialNetworksPrompt;

